/**

 * Simply Amazing Apples — Homepage Controller

 * Handles lightweight cross-section behavior:

 * - Curated collection quick add

 * - Curated assortment toggles

 * - Category jumps

 * - Apple of the Month handoff

 *

 * Commerce-engine behavior lives in saa-commerce.js.

 * Event drawers live in saa-events.js.

 */

(function () {

  'use strict';

 

  const SELECTORS = {

    quickAdd: '[data-quick-add]',

    curatedToggle: '[data-curated-toggle]',

    curatedDetails: '[data-curated-details]',

    jumpFilter: '[data-jump-filter]',

    appleMonthAdd: '[data-apple-month-add]',

    commerceSection: '[data-saa-commerce]',

    commerceFilter: '[data-box-filters] button[data-filter]',

    commerceCard: '.saa-box-card',

    commerceAdd: '[data-select-box-item]'

  };

 

  function sanitizeVariantId(value) {

    return String(value || '').replace(/\D/g, '');

  }

 

  function refreshCart() {

    document.dispatchEvent(new CustomEvent('cart:refresh'));

    document.dispatchEvent(new CustomEvent('cart:update'));

 

    const cartBubble =

      document.querySelector('cart-icon-bubble') ||

      document.querySelector('#cart-icon-bubble');

 

    if (!cartBubble || typeof cartBubble.renderContents !== 'function') return;

 

    fetch('/cart.js', { headers: { Accept: 'application/json' } })

      .then(function (response) {

        if (!response.ok) throw new Error('Unable to refresh cart.');

        return response.json();

      })

      .then(function (cart) {

        cartBubble.renderContents(cart);

      })

      .catch(function (error) {

        console.warn('[SAA] Cart bubble refresh skipped:', error);

      });

  }

 

  function postCartItem(payload) {

    return fetch('/cart/add.js', {

      method: 'POST',

      headers: {

        'Content-Type': 'application/json',

        Accept: 'application/json'

      },

      body: JSON.stringify(payload)

    }).then(function (response) {

      if (response.ok) return response.json();

 

      return response.json().catch(function () {

        return { description: 'Unable to add this item.' };

      }).then(function (error) {

        throw error;

      });

    });

  }

 

  function initQuickAdd(scope) {

    scope.querySelectorAll(SELECTORS.quickAdd).forEach(function (button) {

      if (button.dataset.saaInitialized === 'true') return;

      button.dataset.saaInitialized = 'true';

 

      button.addEventListener('click', function (event) {

        event.preventDefault();

        event.stopPropagation();

 

        const originalText = button.textContent.trim();

        const variantId = sanitizeVariantId(button.dataset.quickAdd);

 

        if (!variantId) {

          button.textContent = 'Variant Needed';

          window.setTimeout(function () {

            button.textContent = originalText;

          }, 1500);

          return;

        }

 

        button.disabled = true;

        button.textContent = 'Adding...';

 

        postCartItem({

          id: Number(variantId),

          quantity: 1,

          properties: {

            'Order Type': 'Pre-Curated Collection',

            Collection:

              button.dataset.collectionTitle || 'Pre-Curated Collection',

            Includes: button.dataset.collectionIncludes || ''

          }

        })

          .then(function () {

            button.textContent = 'Added';

            refreshCart();

 

            window.setTimeout(function () {

              button.textContent = originalText;

              button.disabled = false;

            }, 1500);

          })

          .catch(function (error) {

            console.error('[SAA] Curated quick add failed:', variantId, error);

            button.textContent = 'Try Again';

 

            window.setTimeout(function () {

              button.textContent = originalText;

              button.disabled = false;

            }, 1800);

          });

      });

    });

  }

 

  function initCuratedToggles(scope) {

    scope.querySelectorAll(SELECTORS.curatedToggle).forEach(function (toggle) {

      if (toggle.dataset.saaInitialized === 'true') return;

      toggle.dataset.saaInitialized = 'true';

 

      toggle.addEventListener('click', function () {

        const card = toggle.closest('.saa-curated-card');

        const details = card && card.querySelector(SELECTORS.curatedDetails);

        if (!details) return;

 

        const isOpen = details.classList.toggle('is-open');

        toggle.setAttribute('aria-expanded', String(isOpen));

 

        const openLabel = toggle.dataset.openLabel || 'View Included Flavors +';

        const closeLabel = toggle.dataset.closeLabel || 'Hide Included Flavors −';

        toggle.textContent = isOpen ? closeLabel : openLabel;

      });

    });

  }

 

  function activateCommerceFilter(filter) {

    if (!filter) return false;

 

    const buttons = Array.from(document.querySelectorAll(SELECTORS.commerceFilter));

    const matchingButton = buttons.find(function (button) {

      return button.dataset.filter === filter;

    });

 

    if (!matchingButton) return false;

    matchingButton.click();

    return true;

  }

 

  function scrollToCommerce() {

    const commerce = document.querySelector(SELECTORS.commerceSection);

    if (!commerce) return;

 

    commerce.scrollIntoView({

      behavior: 'smooth',

      block: 'start'

    });

  }

 

  function initCategoryJumps(scope) {

    scope.querySelectorAll(SELECTORS.jumpFilter).forEach(function (trigger) {

      if (trigger.dataset.saaInitialized === 'true') return;

      trigger.dataset.saaInitialized = 'true';

 

      trigger.addEventListener('click', function (event) {

        if (trigger.tagName === 'A') event.preventDefault();

 

        const filter = trigger.dataset.jumpFilter;

        scrollToCommerce();

 

        window.setTimeout(function () {

          activateCommerceFilter(filter);

        }, 350);

      });

    });

  }

 

  function findCommerceCard(category, title) {

    return Array.from(document.querySelectorAll(SELECTORS.commerceCard)).find(

      function (card) {

        return (

          card.dataset.category === category &&

          card.dataset.title === title

        );

      }

    );

  }

 

  function initAppleOfMonth(scope) {

    scope.querySelectorAll(SELECTORS.appleMonthAdd).forEach(function (button) {

      if (button.dataset.saaInitialized === 'true') return;

      button.dataset.saaInitialized = 'true';

 

      button.addEventListener('click', function (event) {

        event.preventDefault();

 

        const featuredTitle = button.dataset.featuredTitle || '';

        const featuredCategory = button.dataset.featuredCategory || '';

 

        scrollToCommerce();

 

        window.setTimeout(function () {

          activateCommerceFilter(featuredCategory);

 

          const matchingCard = findCommerceCard(

            featuredCategory,

            featuredTitle

          );

 

          const addButton = matchingCard &&

            matchingCard.querySelector(SELECTORS.commerceAdd);

 

          if (addButton) addButton.click();

        }, 400);

      });

    });

  }

 

  function init(scope) {

    const context = scope || document;

    initQuickAdd(context);

    initCuratedToggles(context);

    initCategoryJumps(context);

    initAppleOfMonth(context);

  }

 

  document.addEventListener('DOMContentLoaded', function () {

    init(document);

  });

 

  document.addEventListener('shopify:section:load', function (event) {

    init(event.target);

  });

 

  window.SAAHome = {

    init: init,

    refreshCart: refreshCart,

    postCartItem: postCartItem,

    scrollToCommerce: scrollToCommerce,

    activateCommerceFilter: activateCommerceFilter

  };

/* Close the Shop dropdown after a category link is selected */
document.querySelectorAll('[data-saa-header]').forEach(function (header) {
  const shopMenu = header.querySelector('.saa-shop-menu');
  const shopTrigger = header.querySelector('.saa-shop-menu__trigger');
  const dropdownLinks = header.querySelectorAll(
    '.saa-shop-menu__dropdown a'
  );

  if (!shopMenu) return;

  dropdownLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      shopMenu.classList.add('is-closing');

      if (shopTrigger) {
        shopTrigger.setAttribute('aria-expanded', 'false');
        shopTrigger.blur();
      }
    });
  });

  shopMenu.addEventListener('mouseleave', function () {
    shopMenu.classList.remove('is-closing');
  });
});

})();

